import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { builderCustomBuildData } from './builderCustomBuildData'
import { BuilderCustomBuildCard } from './BuilderCustomBuildCard'
import CustomBuildImage1x from './builder-custom-build@1x.png'
import CustomBuildImage2x from './builder-custom-build@2x.png'
import classes from './BuilderCustomBuild.module.scss'

export const BuilderCustomBuild = () => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <div className={classes.content}>
        <Heading size={'lg'} as={'h3'} center balance className={classes.title}>
          Build a native integration with any&nbsp;app & add it inside of your
          product
        </Heading>
        <ul className={classes.list}>
          {builderCustomBuildData.map((item, idx) => (
            <BuilderCustomBuildCard key={idx} item={item} />
          ))}
        </ul>
      </div>
      <div className={classes.visual}>
        <picture className={classes.image}>
          <source
            media='(min-resolution: 2dppx)'
            srcSet={CustomBuildImage2x.src}
          />
          <img
            src={CustomBuildImage1x.src}
            width={335}
            height={270}
            fetchPriority='high'
            alt='Build a native integration with any app & add it inside of your product'
          />
        </picture>
      </div>
    </Block>
  )
}
